import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowUpRight } from 'lucide-react';
const stats = [{
  value: '46',
  label: 'Years of Excellence'
}, {
  value: '150+',
  label: 'Experienced Faculty'
}, {
  value: '3.6k+',
  label: 'Students'
}, {
  value: 'PG to A-Level',
  label: 'Levels'
}];
export function WelcomeSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="about" className="py-20 bg-white" data-id="element-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        <div ref={ref} className="grid md:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-302">
          {/* Left - Overlapping Images with Floating Logo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6
        }} className="relative" data-id="element-303">
            <div className="relative" style={{
            paddingBottom: '110%'
          }} data-id="element-304">
              {/* First Image - Top Left, larger */}
              <div className="absolute top-0 left-0 w-[62%] z-10 rounded-lg overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.3)]" data-id="element-305">
                <img src="https://cdn.magicpatterns.com/uploads/6ESe4A9RxvMShizFWWohnb/about_us_1.jpg" alt="MDIC Campus" className="w-full h-[280px] md:h-[320px] object-cover" data-id="element-306" />
              </div>

              {/* Second Image - Bottom Right, smaller and overlapping */}
              <div className="absolute bottom-0 right-0 w-[55%] z-10 rounded-lg overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.3)]" style={{
              bottom: '110px',
              right: '-5px'
            }} data-id="element-307">
                <img src="https://cdn.magicpatterns.com/uploads/q63EMnFH3EpyCmTprS5HBq/about_us_2.jpg" alt="MDIC Activities" className="w-full h-[220px] md:h-[260px] object-cover" data-id="element-308" />
              </div>
            </div>
          </motion.div>

          {/* Right - Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="pt-4" data-id="element-309">
            <span className="text-primary font-semibold text-lg" data-id="element-310">About</span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-dark mt-2 mb-6 leading-tight" data-id="element-311">
              Manarat Dhaka International School & College (MDIC)
            </h2>
            <p className="text-text-muted leading-relaxed mb-8" data-id="element-312">
              The idea of establishing a premier educational institution to
              provide quality education at an affordable cost in Bangladesh was
              first mooted by a group of prominent academics, business leaders,
              professionals and education enthusiasts. Since its founding, MDIC
              has been committed to nurturing young minds through a perfect
              blend of academic rigor, moral values, and holistic development.
            </p>
            <div className="mb-6" data-id="element-313">
              <span className="text-5xl md:text-6xl font-heading font-bold text-gold" data-id="element-314">
                Since 1976
              </span>
            </div>
            <a href="#" className="inline-flex items-center gap-2 text-primary font-semibold border-b-2 border-primary pb-1 hover:text-primary-dark hover:border-primary-dark transition-colors" data-id="element-315">
              Read more
              <ArrowUpRight size={18} data-id="element-316" />
            </a>
          </motion.div>
        </div>

        {/* Stats Row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-8 pt-8 border-t border-gray-200" data-id="element-317">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-318">
            {stats.map((stat, index) => <div key={index} className={`text-center px-4 ${index < stats.length - 1 ? 'md:border-r md:border-gray-200' : ''}`} data-id="element-319">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary" data-id="element-320">
                  {stat.value}
                </div>
                <div className="text-text-muted text-sm mt-1" data-id="element-321">{stat.label}</div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}